// ==================================================================

// Chinmaya Vidyalaya Senior Secondary School
export const BOOK_ID_CVSSS = [
  // { class: 'CLASS_8', subject: 'Science', bookId: 3 }, // example for testing Teacher
  // { class: 'CLASS_9', subject: 'Science', bookId: 5 }, // example for testing Student

  { class: 'CLASS_6', subject: 'Mathematics - Foundation', bookId: 10614 },
  { class: 'CLASS_7', subject: 'Mathematics - Foundation', bookId: 10615 },
  { class: 'CLASS_8', subject: 'Mathematics - Foundation', bookId: 10616 },
  { class: 'CLASS_9', subject: 'Mathematics - Foundation', bookId: 10617 },
  { class: 'CLASS_10', subject: 'Mathematics - Foundation', bookId: 10618 },
  { class: 'CLASS_6', subject: 'Science - Foundation', bookId: 10619 },
  { class: 'CLASS_7', subject: 'Science - Foundation', bookId: 10620 },
  { class: 'CLASS_8', subject: 'Science - Foundation', bookId: 10621 },
  { class: 'CLASS_9', subject: 'Science - Foundation', bookId: 10622 },
  { class: 'CLASS_10', subject: 'Science - Foundation', bookId: 10623 },
  { class: 'CLASS_11', subject: 'Biology - NEET', bookId: 10624 },
  { class: 'CLASS_12', subject: 'Biology - NEET', bookId: 10625 },
  { class: 'CLASS_11', subject: 'Mathematics - JEE', bookId: 10626 },
  { class: 'CLASS_12', subject: 'Mathematics - JEE', bookId: 10627 },
  { class: 'CLASS_11', subject: 'Chemistry - JEE/NEET', bookId: 10628 },
  { class: 'CLASS_12', subject: 'Chemistry - JEE/NEET', bookId: 10629 },
  { class: 'CLASS_11', subject: 'Physics - JEE/NEET', bookId: 10630 },
  { class: 'CLASS_12', subject: 'Physics - JEE/NEET', bookId: 10631 },
  { class: 'CLASS_11', subject: 'Chemistry', bookId: 10113 },
  { class: 'CLASS_12', subject: 'Chemistry', bookId: 10004 },
  { class: 'CLASS_11', subject: 'Math', bookId: 10111 },
  { class: 'CLASS_12', subject: 'Math', bookId: 10003 },
  { class: 'CLASS_11', subject: 'Physics', bookId: 10112 },
  { class: 'CLASS_12', subject: 'Physics', bookId: 10006 },
  { class: 'CLASS_11', subject: 'Biology', bookId: 10604 },
  { class: 'CLASS_12', subject: 'Biology', bookId: 10605 },
  { class: 'CLASS_6', subject: 'Science', bookId: 10477 },
  { class: 'CLASS_7', subject: 'Science', bookId: 10478 },
  { class: 'CLASS_8', subject: 'Science', bookId: 10479 },
  { class: 'CLASS_9', subject: 'Science', bookId: 10480 },
  { class: 'CLASS_10', subject: 'Science', bookId: 10481 },
  { class: 'CLASS_6', subject: 'Maths', bookId: 10472 },
  { class: 'CLASS_7', subject: 'Maths', bookId: 10473 },
  { class: 'CLASS_8', subject: 'Maths', bookId: 10474 },
  { class: 'CLASS_9', subject: 'Maths', bookId: 10475 },
  { class: 'CLASS_10', subject: 'Maths', bookId: 10476 },
];

// ==================================================================
